import {
  Alert,
  Button,
  CardContent,
  CircularProgress,
  Grid,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SendIcon from "@mui/icons-material/Send";
import RemoveIcon from "@mui/icons-material/Delete";
import Parse from "parse";
import { useDispatch, useSelector } from "react-redux";
import { setNotification } from "../redux/slices/notificationsSlice";
import heic2any from "heic2any";

const ImageUpload = ({ goBack }) => {
  const [selectedFile, setSelectedFile] = useState();
  const [imageUrl, setImageUrl] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [imageSending, setImageSending] = useState(false);
  const { t } = useTranslation();
  const user = useSelector((state) => state.user.userMe);
  const dispatch = useDispatch();

  const handleUploadClick = async (event) => {
    if (event?.target?.files[0].type.indexOf("image") >= 0) {
      let file = null;
      if (
        event.target.files[0] &&
        event.target.files[0].type.match(/image.*/)
      ) {
        setImageUploading(true);
        setSelectedFile(null);
        // get image as blob url
        let blobURL = URL.createObjectURL(event.target.files[0]);

        // convert "fetch" the new blob url
        let blobRes = await fetch(blobURL);

        // convert response to blob
        let blob = await blobRes.blob();

        // convert HEIC to PNG
        if (event.target.files[0].type === "image/heic") {
          blob = await heic2any({ blob, toType: "image/png", quality: 0.5 });
        }

        const img = new Image();
        img.src = URL.createObjectURL(blob);
        await new Promise((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = reject;
        });
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const MAX_WIDTH = 1024;
        const MAX_HEIGHT = 1024;
        let width = img.width;
        let height = img.height;
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        const resizedBlob = await new Promise((resolve) =>
          canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.8)
        );

        file = resizedBlob;
      } else if (event.target?.files) {
        setImageUploading(true);
        setSelectedFile(null);
        file = event.target.files[0];
      }
      setImageUrl(URL.createObjectURL(file));
      setSelectedFile(file);
      event.target.value = "";
    } else {
      alert("Tip fajla nije dozvoljen!");
    }
  };
  const removeImage = () => {
    URL.revokeObjectURL(selectedFile);
    setSelectedFile(null);
    setImageUrl(null);
  };
  const sendImage = async () => {
    const parseFile = new Parse.File(selectedFile.name, selectedFile);
    setImageSending(true);
    parseFile
      .save()
      .then(async (response) => {
        const Gallery = Parse.Object.extend("Gallery");
        const gallery = new Gallery();
        gallery.set("picture", response);
        gallery.set("username", user.username);
        await gallery.save();
        dispatch(
          setNotification({
            show: true,
            message: t("notifications.successUploadImage"),
            severity: "success",
          })
        );
        setImageSending(false);
        removeImage();
      })
      .catch((err) => {
        dispatch(
          setNotification({
            show: true,
            message: t("notifications.notifications"),
            severity: "error",
          })
        );
        setImageSending(false);
      });
  };

  useEffect(() => {
    if (selectedFile) {
      setImageUploading(false);
    }
  }, [selectedFile]);

  return (
    <CardContent>
      <Stack spacing={2} padding="8px" alignItems="center" direction="row">
        <Alert severity="info">
          {t("qrCodeScanner.uploadImageExplanationText")}
        </Alert>
      </Stack>
      <Stack padding="8px">{imageUploading && <LinearProgress />}</Stack>
      <Grid container direction="column" justify="center" alignItems="center">
        <Stack direction="row">
          <Button onClick={goBack}>{t("qrCodeScanner.goBack")}</Button>
          <>
            <input
              id="contained-button-file"
              multiple
              type="file"
              onChange={handleUploadClick}
              style={{ display: "none" }}
            />
            <label htmlFor="contained-button-file">
              <Button
                disabled={!!imageUploading || !!imageUrl}
                variant="contained"
                color="primary"
                component="span"
              >
                {t("qrCodeScanner.uploadImage")}
              </Button>
            </label>
          </>
        </Stack>
        {imageUrl && selectedFile && (
          <Box
            mt={2}
            textAlign="center"
            justify="center"
            style={{ maxWidth: "85vw", position: "relative" }}
          >
            <Typography>{t("qrCodeScanner.yourImage")}</Typography>
            <img
              src={imageUrl}
              alt={selectedFile.name}
              style={{
                maxWidth: "75vw",
                position: "relative",
              }}
            />
            <Stack direction="row">
              <Button
                onClick={sendImage}
                variant="contained"
                color="primary"
                startIcon={<SendIcon />}
                style={{ position: "absolute", left: 10, bottom: 10 }}
                disabled={imageSending}
              >
                {imageSending ? <CircularProgress /> : t("qrCodeScanner.send")}
              </Button>
              <Button
                onClick={removeImage}
                variant="contained"
                color="error"
                startIcon={<RemoveIcon />}
                style={{ position: "absolute", right: 10, bottom: 10 }}
              >
                {t("qrCodeScanner.remove")}
              </Button>
            </Stack>
          </Box>
        )}
      </Grid>
    </CardContent>
  );
};
export default ImageUpload;
